import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'day8-ui';
import { FaFireFlameCurved } from "@react-icons/all-files/fa6/FaFireFlameCurved";
import { getSelectedFilters, onFilterSelect } from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';
import { useDispatch } from 'react-redux';

// Boolean toggle: when active, the calendar shows only package options that are nearly
// sold out (see the `lastMinute` predicate in reducers/bookingOptions.js). Unlike the
// multi-select filters, both modes toggle the param directly rather than opening a sub-menu.
const LastMinuteFilter = props => {
  const dispatch = useDispatch();
  const isActive = !!getSelectedFilters(props.location)[FILTERS.LAST_MINUTE];
  const toggle = () => onFilterSelect(
    props.location,
    dispatch,
    props.filterAction,
    FILTERS.LAST_MINUTE,
    isActive ? null : 'active'
  );
  return props.mobile ? (
    <div className={props.className}>
      <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Last minute</h3>
      <div className='dui-flex dui-flex-wrap dui-gap-4 dui-mt-4'>
        <Button
          buttonType={isActive ? 'FILTER_ACTIVE' : 'FILTER'}
          leftIcon={<FaFireFlameCurved />}
          onClick={toggle}
        >
          Nearly sold out
        </Button>
      </div>
    </div>
  ) : (
    <Button buttonType="LINK" leftIcon={<FaFireFlameCurved />} onClick={toggle}>
      {isActive ? 'Last minute: on' : 'Last minute'}
    </Button>
  );
};
LastMinuteFilter.propTypes = {
  mobile: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string,
  location: PropTypes.object,
  filterAction: PropTypes.func.isRequired
};
export default LastMinuteFilter;
